<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
        </ion-buttons>
        <ion-searchbar placeholder="Search Product" debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
        <ion-button (click)="showOnlySpares = !showOnlySpares; loadProducts()" fill="outline" shape="round"
                    color="medium" expand="full"
                    *ngIf="document.documentType === 7 && behaviour.toLowerCase() !== 'fuel'">
            {{ showOnlySpares ? 'Switch to All Products' : 'Switch to Spares' }}
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchProducts($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Equipment...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-content>
        <ion-virtual-scroll [items]="productList | filterDetailLine: queryText" *ngIf="!showOnlySpares">
            <ion-item *virtualItem="let prod" (click)="prod.isChecked = !prod.isChecked">
                <ion-checkbox [(ngModel)]="prod.isChecked" color="success"></ion-checkbox>
                <ion-label class="ion-text-wrap ion-padding-start">
                    <h4>{{prod.plu}}</h4>
                    <p>{{prod.description}}</p>
                    <p *ngIf="prod.supplierRef !== null && prod.supplierRef != '' "><b>Supplier Ref :</b> {{prod.supplierRef}}</p>
                    <p *ngIf="prod.binLocations !== null && prod.binLocations != '' " ><b>Bin Locations :</b> {{prod.binLocations}}</p>
                    <!-- Show either physical or on order stock level-->
                    <p *ngIf="prod.physicalStock !== null && prod.physicalStock > 0 " ><b>Stock :</b> {{prod.physicalStock}}</p>
                    <p *ngIf="prod.onOrderStock !== null && prod.physicalStock <= 0 " ><b>On Order :</b> {{prod.onOrderStock}}</p>
                </ion-label>
                <ion-input type="number" [(ngModel)]="prod.qty" placeholder="1" (ionChange)="prod.isChecked = true"
                           class="ion-text-end ion-padding-end" #inputProd></ion-input>
            </ion-item>
        </ion-virtual-scroll>
        <ion-virtual-scroll [items]="sparesList | filterDetailLine: queryText" *ngIf="showOnlySpares">
            <ion-item *virtualItem="let spare" (click)="spare.isChecked = !spare.isChecked">
                <ion-checkbox [(ngModel)]="spare.isChecked" color="success"></ion-checkbox>
                <ion-label class="ion-text-wrap ion-padding-start">
                    <h4>{{spare.plu}}</h4>
                    <p>{{spare.description}}</p>
                    <p *ngIf="spare.supplierRef !== null && spare.supplierRef != '' " ><b>Supplier Ref :</b> {{spare.supplierRef}}</p>
                    <p *ngIf="spare.binLocations !== null && spare.binLocations != '' " ><b>Bin Locations :</b> {{spare.binLocations}}</p>
                    <!-- Show either physical or on order stock level-->
                    <p *ngIf="spare.physicalStock !== null && spare.physicalStock > 0 " ><b>Stock :</b> {{spare.physicalStock}}</p>
                    <p *ngIf="spare.onOrderStock !== null && spare.physicalStock <= 0 " ><b>On Order :</b> {{spare.onOrderStock}}</p>
                </ion-label>
                <ion-input type="number" [(ngModel)]="spare.qty" placeholder="1" (ionChange)="spare.isChecked = true"
                           class="ion-text-end ion-padding-end" #inputProd></ion-input>
            </ion-item>
        </ion-virtual-scroll>
    </ion-content>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="addProducts()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer>
    <p class="ion-text-center" style="color: darkgrey">Last Update: {{lastUpdate | date: "dd/MM/yyyy HH:mm:ss"}}</p>
</ion-footer>
